import { Typography } from 'antd';
import type { HTMLAttributes, ReactNode } from 'react';
import tw from 'twin.macro';

import { BANK_TRANSFER_INFO } from '@/constants';

interface BankTransferItemProps {
  title?: ReactNode;
  customCss?: HTMLAttributes<unknown>['css'];
}

const BankTransferItem = ({ title, customCss }: BankTransferItemProps) => {
  return (
    <dl css={[tw`pt-[4px] w-full text-[14px] leading-[22px]`, customCss]}>
      <dt css={tw`mb-[8px]`}>
        {title ?? (
          <Typography.Text css={tw`text-[rgba(0, 0, 0, 0.45)]`}>
            신청 완료 후 아래 계좌로 입금해주세요. 원활한 확인을 위해 파트너
            명의로 입금해주세요.
          </Typography.Text>
        )}
      </dt>
      <dd
        css={tw`bg-[#f5f5f5] w-full p-[16px 12px] rounded-[8px] font-semibold text-center mt-[4px]`}
      >
        {BANK_TRANSFER_INFO.ACCOUNT}
      </dd>
    </dl>
  );
};

export default BankTransferItem;
